import { Component, Input, OnInit } from '@angular/core';
import { CNVaccine } from 'src/app/models/cnvaccine';

@Component({
  selector: 'app-vaccine',
  templateUrl: './vaccine.component.html',
  styleUrls: ['./vaccine.component.scss']
})
export class VaccineComponent implements OnInit {

  @Input() vaccine = new CNVaccine();

  constructor() { }

  ngOnInit(): void {
  }

}
